export default "__VITE_ASSET__b25ab345__"